<template>
  <div class="custom_6">
       {{describe}}
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      type: Object,
      required: true
    }

  },
    data(){
        return {
            describe :""

        }
    },
    methods:{

    },
    mounted(){
      // 
      console.log(this.payload)
      this.describe = JSON.parse(this.payload.data).data.describe
       

        
    }

};
</script>
<style lang="scss" scoped>
.custom_6 {

}
</style>